<style lang="scss" scoped>
  .document-image-pager {
    .page-image {
      width: 100%;
      max-height: 450px;
      object-fit: contain;
      cursor: zoom-in;
    }

    .pager-thumbnails {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 6px;
      padding-top: 8px;
    }
  }

  .reader-image {
    width: 100%;
    height: auto;
  }

  .reader-thumbnails {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
    position: sticky;
    bottom: 0;
    margin: 0 -1rem -1rem;
    padding: 12px 1rem;
    background-color: #fff;
  }

  .pager-thumbnail {
    width: 56px;
    height: 56px;
    padding: 0;
    border: 2px solid transparent;
    border-radius: 6px;
    background-color: #f4f4f4;
    overflow: hidden;
    cursor: pointer;

    &.current {
      border-color: var(--primary);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
</style>

<template>
  <div class="document-image-pager">
    <img
      v-b-tooltip="{ title: $t('postView.expandImage'), placement: 'right', trigger: 'hover' }"
      class="page-image rounded"
      :src="imageUrls[currentPage]"
      :alt="$t('postView.altMessageAttachment')"
      @click="readerOpen = true"
    >
    <div v-if="imageUrls.length > 1" class="pager-thumbnails" cy="pager-thumbnails">
      <button
        v-for="(imageUrl, index) in imageUrls"
        :key="index"
        type="button"
        class="pager-thumbnail"
        :class="{ current: index === currentPage }"
        :aria-label="`${$t('postView.pager.page')} ${index + 1}`"
        @click="currentPage = index"
      >
        <img :src="imageUrl" :alt="`${$t('postView.pager.page')} ${index + 1}`">
      </button>
    </div>

    <b-modal v-model="readerOpen" :title="readerTitle" size="xl" centered hide-footer>
      <img class="reader-image" :src="imageUrls[currentPage]" :alt="$t('postView.altExpandedAttachment')">
      <div v-if="imageUrls.length > 1" class="reader-thumbnails" cy="reader-thumbnails">
        <button
          v-for="(imageUrl, index) in imageUrls"
          :key="index"
          type="button"
          class="pager-thumbnail"
          :class="{ current: index === currentPage }"
          :aria-label="`${$t('postView.pager.page')} ${index + 1}`"
          @click="currentPage = index"
        >
          <img :src="imageUrl" :alt="`${$t('postView.pager.page')} ${index + 1}`">
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    props: {
      imageUrls: {
        required: true,
        type: Array,
      },
    },
    data() {
      return {
        currentPage: 0,
        readerOpen: false,
      };
    },
    computed: {
      pageCounter() {
        return `${this.currentPage + 1} / ${this.imageUrls.length}`;
      },
      readerTitle() {
        return `${this.$t('postView.pager.page')} ${this.pageCounter}`;
      },
    },
  };
</script>
